import { createContext } from "react";
import { TypeSessaoDaAreaRestrita } from "../../Models/Domain/AreaRestrita/Sessao";

export type TypeSessaoContext = {
  sessao: TypeSessaoDaAreaRestrita | null;
  setSessao: React.Dispatch<React.SetStateAction<TypeSessaoDaAreaRestrita | null>>;
}

export const SessaoARContext = createContext<TypeSessaoContext | null>(null);